// Constantes e utilitários comuns

// Simular delay de rede para desenvolvimento
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// Tempos de delay padrão para diferentes operações
export const delayTimes = {
  fast: 300,
  medium: 500,
  slow: 800,
  upload: 1000
}

// URLs base padrão
export const defaultUrls = {
  api: 'http://localhost:3000/api',
  business: 'http://localhost:3000/architecture/business-new',
  keycloak: 'http://localhost:8080'
}

// Configurações de timeout
export const timeoutConfig = {
  api: 10000, // 10 segundos
  upload: 30000 // 30 segundos
}